<style lang="scss">
@import "@/sass/commons/_variables";
.env-row {
  margin-top: 22vh;
  margin-bottom: -22vh;
  color: var(--primary-color);
  font-size: 2rem;
  word-wrap: break-word;
  font-family: monospace;
  text-align: center;
}

#app > .header {
  font-family: $font-default;
  & > div {
    display: flex;
    align-items: center;
  }
  z-index: 3;
}
.primary-header {
  background-color: white;
  height: 4rem;
  font-size: 0.9rem;
  color: $primary-color;
  font-weight: 500;
}
.logoHeaderStyle {
  max-height: 70px;
  border-radius: 12px;
}
.logoHeaderStyle2 {
  max-height: 70px;
  border-radius: 12px;
  max-width: 500px;
}
.logoHeaderStyleMobile {
  max-height: 60px;
  border-radius: 12px;
}

.secondary-header {
  background-color: $ternary-color;
  height: 2.3rem;

  .menus {
    display: flex;
    justify-content: space-evenly;
    width: 60%;

    .hvr-underline-from-center:before {
      background: white;
    }

    .menu {
      display: inline-block;
      &.active {
        box-shadow: inset 0px -6px 0px 0px white;
      }
      a {
        display: inline-block;
        padding: 0.5rem;
        color: white;
        font-size: 0.9rem;
        height: 2.3rem;
        font-weight: 500;
      }
      &:hover {
        color: $primary-color;
        cursor: pointer;
      }
    }
  }
}
.menuDropDown {
  z-index: 1;
  position: absolute !important;
  margin-top: -8px;
  background-color: $ternary-color;
  margin-left: 56px;
  width: 50%;
  span:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
.menuLink {
  border: 1px solid white !important;
}
.header-upper-containear {
  background: var(--primary-color);
  height: 11vh;
  display: flex;
  align-items: center;
}
.header-upper-logo {
  flex: 1;
  margin-left: 50px;
}
.header-upper-icon {
  color: white;
  margin-right: 12px;
  cursor: pointer;
}
.header-upper-icon:hover {
  color: white !important;
  text-decoration: none !important;
  cursor: pointer;
}
.header-upper-icon-insta:hover {
  color: var(--primary-color)!important;
  text-decoration: none !important;
  cursor: pointer;
}
.header-upper-icon-insta {
  background: white;
  color: var(--primary-color);
  border-radius: 50%;
  padding: 4px;
  margin-right: 12px;
  cursor: pointer;
}
.header-upper-suport-containear {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 22px;
  margin-right: 12px;
  cursor: pointer;
}
.header-upper-icon-whats {
  color: white;
  background: orangered;
  padding: 5px;
  border-radius: 50%;
}
.header-upper-icon-whats-text {
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 19px;
  color: var(--primary-color);
  margin-left: 7px;
  margin-right: 10px;
}
.header-upper-icon-divider {
  border-right: 1px solid white;
  margin-right: 15px;
}
.header-upper-user-text {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #ffffff;
  margin-right: 20px;
}
/* O seletor de conta so existe para quem alcanca mais de uma: herda o estilo
   do nome para que, com uma conta so, o cabecalho fique identico ao de antes. */
.account-switcher {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  user-select: none;
}
.account-switcher-caret {
  font-size: 20px;
  transition: transform 0.15s ease;
}
.account-switcher--open .account-switcher-caret {
  transform: rotate(180deg);
}
.account-switcher-list {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  min-width: 260px;
  max-height: 320px;
  overflow-y: auto;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}
.account-switcher-item {
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  color: #303030;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
}
.account-switcher-item:hover {
  background: #f5f5f5;
}
.account-switcher-item--current {
  font-weight: 600;
  cursor: default;
}
.account-switcher-item-user {
  font-size: 12px;
  color: #808080;
}
.account-switcher-search {
  padding: 8px 12px;
}
.account-switcher-search-input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 13px;
}
.account-switcher-group {
  padding: 8px 12px 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #8c8c8c;
  cursor: default;
}
.account-switcher-hint {
  padding: 6px 12px;
  font-size: 12px;
  color: #8c8c8c;
  cursor: default;
}
.account-switcher-error {
  color: #d32f2f;
}
.account-switcher-badge {
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--primary-color, #ff5722);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.header-lower-containear {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 20px;
  color: #605f5f;
  padding-top: 7px;
  padding-bottom: 9px;
  margin-bottom: 11px;
  box-shadow: 0px 5px 8px 0px lightgrey;
  min-height: 50px;
  background-color: white;
}
.header-lower-texts {
  /* margin-right: 5vw; */
  cursor: pointer;
  color: #605f5f;
  font-size: 0.8rem;
}
.header-lower-texts:hover {
  color: #605f5f !important;
}
.header-lower-texts-activate {
  border-bottom: 3px solid var(--secondary-color);
  padding-bottom: 5.5px;
}
.header-contact-list {
  position: absolute;
  right: 20px;
  top: 100px;
  z-index: 10;
}
.header-contact-list-row {
  background-color: var(--primary-color);
  border-radius: 5px;
  padding: 2px 4px;
  margin-bottom: 10px;
}
.header-contact-list-row-text {
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 19px;
  color: white;
}
.mobile-header {
  display: none;
}
.mobile-header-logo-containear {
  width: 100%;
  display: flex;
  justify-content: center;
}
.mobile-side-menu-containear {
  position: absolute;
  z-index: 3;
  top: 0;
  background-color: white;
  min-width: 100%;
  min-height: 100vh;
}
.account-icon {
  font-size: 35px;
  color: white;
  margin-right: 15px;
}
.header-upper-icons {
  margin-right: 12px;
}
.mobile-header-img-logo {
  width: 100vw;
  max-width: 280px;
  min-width: 120px;
  height: auto;
}
.desktop-header {
  position: fixed;
  width: 100%;
  z-index: 4;
}
.mobile-only{
    display: none !important;
}
@media only screen and (max-width: 630px) {
  .desktop-header {
    display: none;
  }
  .env-row {
    margin-top: 20vh;
    margin-bottom: 0;
  }
  /* .mobile-header {
    background: var(--primary-color);
    height: 8vh;
    display: flex;
    align-items: center;
    z-index: 10;
    padding: 35px 0;
  } */
  .mobile-only{
    display: flex !important;
    margin-top: 9vh;
  }
  .header-lower-texts{
    text-align: center;
  }
  .header-lower-containear{
    /* gap: 4vw; */
  }
  .mobile-header{
        background: var(--primary-color);
        /* background-color: red !important; */
        height: 8vh;
        display: grid !important;
        grid-template-columns: 1fr 1fr 1fr !important;
        align-content: center;
        /* display: flex; */
        /* align-items: center; */
        z-index: 10;
        padding: 35px 0;
    }
}
.mobile-header-menu-icon {
  color: white;
  margin-left: 15px;
  cursor: pointer;
}

.contact {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  a {
    display: inline-block;
  }
  i {
    font-size: 1.7rem;
    margin-left: 14px;
    cursor: pointer;
  }
  .support {
    cursor: pointer;
    width: 123px;
    height: 100%;
    display: inline-flex;
    align-items: center;
    border: 1px solid #4ac959;
    color: #4ac959;
    border-radius: 5px;
    i {
      margin-right: 4px;
    }
    .support-contacts {
      transform: translateX(160%);
      position: fixed;
      top: 40px;
      right: 142px;
      list-style: none;
      li {
        padding: 6px;
        padding-right: 14px;
        border: 1px solid #4ac959;
        border-radius: 6px;
        background-color: white;
        margin-bottom: 6px;
        &:hover {
          color: white;
          border: 1px solid $primary-color;
          background-color: $primary-color;
          i,
          a {
            color: white;
          }
        }
        i {
          font-size: 1rem;
        }
        a {
          color: #4ac959;
        }
      }
    }
  }
  .support-remote {
    cursor: pointer;
    width: 123px;
    height: 100%;
    display: inline-flex;
    align-items: center;
    border-radius: 5px;
    border: 1px solid red;
    color: red;
    i {
      margin-right: 4px;
    }
  }
}
</style>
<template>
  <div>
    <div class="desktop-header">
      <div class="header-upper-containear not-print">
        <router-link
          :to="{ name: 'monitors-page', params: { tab: 'cotacoes' } }"
          class="header-upper-logo"
        >
          <!-- <img src="@/assets/Logo-BRANCA.svg" /> -->
          <img
            :class="
              this.whitelabel.data.imgs.img_logo != null ? 'logoHeaderStyle' : 'logoHeaderStyle2'
            "
            :src="
              this.whitelabel.data.imgs.img_logo != null
                ? this.whitelabel.data.imgs.img_logo
                : require('@/assets/Logo-BRANCA.svg')
            "
            alt="Logo Clube da Cotação"
          />
        </router-link>
        <a
          href="https://www.facebook.com/clubdacotacao"
          class="header-upper-icons"
          target="_blank"
        >
          <img src="@/assets/Facebook_black.svg" alt="" />
        </a>
        <a
          href="https://www.instagram.com/clubdacotacao/"
          class="header-upper-icons"
          target="_blank"
        >
          <img src="@/assets/Instagram_black.svg" alt="" />
        </a>
        <a
          href="mailto:contato@clubdacotacao.com.br"
          class="header-upper-icons"
          target="_blank"
        >
          <img src="@/assets/Mail_black.svg" alt="" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCiP8ACo7VDoIzlUwVC5m5Xw"
          class="header-upper-icons"
          target="_blank"
        >
          <img src="@/assets/Youtube_black.svg" alt="" />
        </a>
        <!-- <div class="header-upper-suport-containear" @click="present_numbers = !present_numbers">
                    <img src="@/assets/WhatsApp_black.svg" alt="">
                    <div class="header-upper-icon-whats-text">Suporte</div>
                </div> -->
        <div v-if="present_numbers" class="header-contact-list">
          <div class="header-contact-list-row">
            <i class="fa fa-user" />
            <a
              class="header-contact-list-row-text"
              href="https://api.whatsapp.com/send?phone=5581996490176"
              target="_blank"
            >
              +55 (81) 99649-0176
            </a>
          </div>
          <div class="header-contact-list-row">
            <i class="fa fa-user" />
            <a
              class="header-contact-list-row-text"
              href="https://api.whatsapp.com/send?phone=5581997413889"
              target="_blank"
            >
              +55 (81) 99741-3889
            </a>
          </div>
          <div class="header-contact-list-row">
            <i class="fa fa-user" />
            <a
              class="header-contact-list-row-text"
              href="https://api.whatsapp.com/send?phone=5581997410500"
              target="_blank"
            >
              +55 (81) 99741-0500
            </a>
          </div>
        </div>
        <!-- <p @click="handleParagraphClick">testee</p> -->
        <div class="header-upper-icon-divider">
          <div
            @click="openPage('https://anydesk.com/pt/downloads')"
            class="header-upper-suport-containear"
          >
            <img src="@/assets/Rectangle_32.svg" />
            <div class="header-upper-icon-whats-text">Anydesk</div>
          </div>
        </div>
        <span class="material-icons account-icon">account_circle</span>
        <!-- Com uma conta so (ou nenhuma), o cabecalho fica exatamente como
             antes: /login/accounts devolve lista vazia para quem nao tem
             login_id, e um seletor que nao troca nada e pior que nenhum. -->
        <div
          v-if="can_switch_account"
          class="header-upper-user-text account-switcher"
          :class="{ 'account-switcher--open': account_menu_open }"
          @click="toggle_account_menu"
        >
          {{ user.user_name }}
          <span class="material-icons account-switcher-caret">expand_more</span>
          <ul v-if="account_menu_open" class="account-switcher-list" @click.stop>
            <li v-if="is_master" class="account-switcher-search">
              <input
                v-model="master_query"
                class="account-switcher-search-input"
                type="search"
                placeholder="Buscar empresa, CNPJ ou código"
                @input="schedule_master_search"
              />
            </li>
            <li
              v-for="account in switchable_accounts"
              :key="account_key(account)"
              class="account-switcher-item"
              :class="{ 'account-switcher-item--current': account.id === current_account_id }"
              @click.stop="switch_account(account)"
            >
              <span class="account-switcher-item-name">
                {{ account.client_name || account.provider_name || account.name }}
                <span v-if="account.is_master_access" class="account-switcher-badge">Master</span>
              </span>
              <span class="account-switcher-item-user">{{ account.name }}</span>
            </li>
            <template v-if="is_master && master_query.trim().length >= min_search_length">
              <li class="account-switcher-group">Acesso master</li>
              <li v-if="master_status === 'loading'" class="account-switcher-hint">Buscando…</li>
              <li v-else-if="master_status === 'error'" class="account-switcher-hint">Não foi possível buscar.</li>
              <li v-else-if="visible_master_results.length === 0" class="account-switcher-hint">
                Nenhum cliente ou fornecedor ativo encontrado.
              </li>
              <li
                v-for="account in visible_master_results"
                :key="account_key(account)"
                class="account-switcher-item"
                @click.stop="switch_account(account)"
              >
                <span class="account-switcher-item-name">
                  {{ account.client_name || account.provider_name }}
                  <span class="account-switcher-badge">Master</span>
                </span>
                <span class="account-switcher-item-user">{{ account.type === 'provider' ? 'Fornecedor' : 'Cliente' }}</span>
              </li>
            </template>
            <li v-if="switch_error" class="account-switcher-hint account-switcher-error">{{ switch_error }}</li>
          </ul>
        </div>
        <div v-else class="header-upper-user-text">
          {{ user.user_name }}
        </div>
      </div>
      <div class="header-lower-containear not-print">
        <router-link
          :class="{
            'header-lower-texts-activate': $route.params.tab == 'cotacoes',
          }"
          :to="{ name: 'monitors-page', params: { tab: 'cotacoes' } }"
          class="header-lower-texts"
          >Monitor de Cotação</router-link
        >
        <router-link
          :class="{
            'header-lower-texts-activate': $route.params.tab == 'ressuprimento',
          }"
          :to="{ name: 'monitors-page', params: { tab: 'ressuprimento' } }"
          class="header-lower-texts"
          >Monitor de Ressuprimento</router-link
        >
        <router-link
          :class="{
            'header-lower-texts-activate': $route.name == 'repurchase-page',
          }"
          :to="{ name: 'repurchase-page' }"
          class="header-lower-texts"
          >Monitor de Divergência</router-link
        >
        <router-link
          :class="{
            'header-lower-texts-activate': $route.params.tab == 'mobile',
          }"
          :to="{ name: 'monitors-page', params: { tab: 'mobile' } }"
          class="header-lower-texts"
          >Lista Mobile</router-link>
        <router-link
          :class="{
            'header-lower-texts-activate': $route.params.tab == 'pedidos',
          }"
          :to="{ name: 'monitors-page', params: { tab: 'pedidos' } }"
          class="header-lower-texts"
          >Pedidos</router-link
        >
        <router-link
          :class="{
            'header-lower-texts-activate': $route.params.tab == 'entregas',
          }"
          :to="{ name: 'monitors-page', params: { tab: 'entregas' } }"
          class="header-lower-texts"
          >Monitor de entregas</router-link
        >
        <!-- <router-link :class="{ 'header-lower-texts-activate': $route.params.tab == 'price' }" :to="{ name: 'monitors-page', params: { tab: 'price' } }" class="header-lower-texts">Monitor Preço de Venda Varejo</router-link> -->
      </div>
    </div>
    <div class="mobile-header">
      <i
        class="fa-solid fa-bars fa-2x mobile-header-menu-icon"
        v-on:click="setMobileMenu(true)"
      ></i>
      <div class="mobile-header-logo-containear">
        <router-link
          :to="{ name: 'monitors-page', params: { tab: 'cotacoes' } }"
        >
          <!-- <img src="@/assets/Logo-BRANCA.svg" class="mobile-header-img-logo" /> -->
          <img
            :class="
              this.whitelabel.data.imgs.img_logo !== null
                ? 'logoHeaderStyleMobile'
                : 'mobile-header-img-logo'
            "
            :src="
              this.whitelabel.data.imgs.img_logo !== null
                ? this.whitelabel.data.imgs.img_logo
                : require('@/assets/Logo-BRANCA.svg')
            "
            alt="Logo Clube da Cotação"
          />
        </router-link>
      </div>
    </div>
    <div class="header-lower-containear not-print mobile-only">
                <router-link :class="{ 'header-lower-texts-activate': $route.params.tab == 'cotacoes' }" :to="{ name: 'monitors-page', params: { tab: 'cotacoes' } }" class="header-lower-texts">Cotação</router-link>
                <router-link :class="{ 'header-lower-texts-activate': $route.params.tab == 'ressuprimento' }" :to="{ name: 'monitors-page', params: { tab: 'ressuprimento' } }" class="header-lower-texts">Ressuprimento</router-link>
                <!-- <router-link :class="{ 'header-lower-texts-activate': $route.name == 'repurchase-page' }" :to="{ name: 'repurchase-page' }" class="header-lower-texts">Divergência</router-link> -->
                <router-link :class="{ 'header-lower-texts-activate': $route.params.tab == 'mobile' }" :to="{ name: 'monitors-page', params: { tab: 'mobile' } }" class="header-lower-texts">Mobile</router-link>
                <router-link :class="{ 'header-lower-texts-activate': $route.params.tab == 'pedidos' }" :to="{ name: 'monitors-page', params: { tab: 'pedidos' } }" class="header-lower-texts">Pedidos</router-link>
                <!-- <router-link :class="{ 'header-lower-texts-activate': $route.params.tab == 'price' }" :to="{ name: 'monitors-page', params: { tab: 'price' } }" class="header-lower-texts">Monitor Preço de Venda Varejo</router-link> -->
        </div>
    <div v-if="ENV != 'prod'" class="not-print env-row">
      Você esta em ambiente apresentação.
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/constants/constants";
import Breadcrumb from "@/components/shared/Breadcrumb";
import SessionService from "@/services/TokenService";
import AuthService from "@/services/AuthService";
import {
  MIN_SEARCH_LENGTH,
  SEARCH_DEBOUNCE_MS,
  accountKey,
  redirectUrlFor,
  isSameApp,
} from "@/services/masterAccess";
import { mapState, mapGetters } from "vuex";
import { gsap } from "gsap";

export default {
  components: {
    ccBreadcrumb: Breadcrumb,
  },
  props: ["breadcrumbs", "setMobileMenu"],
  data() {
    return {
      user_name: null,
      ENV: CONSTANTS.PROJECT_ENV,
      API_URL: CONSTANTS.API_URL,
      session: new SessionService(),
      auth_svc: new AuthService(),
      switchable_accounts: [],
      current_account_id: null,
      account_menu_open: false,
      switching_account: false,
      is_master: false,
      master_query: "",
      master_results: [],
      master_status: "idle",
      master_timer: null,
      master_request: 0,
      switch_error: null,
      min_search_length: MIN_SEARCH_LENGTH,
      isHidden: true,
      tab: "",
      present_numbers: false,
    };
  },
  methods: {
    handleParagraphClick() {
      console.log(this.whitelabel.data);
    },
    openPage(url) {
      window.open(url, "_blank");
    },
    toggle_account_menu() {
      // Reabrir o menu com um erro de uma tentativa anterior confunde: o
      // usuario ve "nao foi possivel" sem ter clicado em nada ainda.
      this.account_menu_open = !this.account_menu_open;
      this.switch_error = null;
    },
    // Mesmo fluxo que src/services/v3/http.js aplica no 401 das suas proprias
    // chamadas. As chamadas daqui passam por Http.js (sem interceptor), entao
    // precisam replicar o tratamento na mao.
    handle_session_expired() {
      this.$store.dispatch("notification/add", {
        type: "error",
        message: "Sua sessão expirou.",
      });
      this.$store.dispatch("user/logout");
      window.location.assign(CONSTANTS.ROUTE_LOGIN);
    },
    load_switchable_accounts() {
      // Falha em silencio de proposito: o seletor e conveniencia, e um erro
      // aqui nao pode atrapalhar o cabecalho inteiro. Sem lista, sem seletor.
      this.auth_svc
        .my_accounts()
        .then(({ data }) => {
          this.switchable_accounts = (data && data.accounts) || [];
          this.current_account_id = data && data.current_user_id;
          this.is_master = Boolean(data && data.is_master);
        })
        .catch((err) => {
          if (err && err.response && err.response.status === 401) {
            this.handle_session_expired();
            return;
          }
          this.switchable_accounts = [];
          this.is_master = false;
        });
    },
    account_key(account) {
      return accountKey(account);
    },
    schedule_master_search() {
      clearTimeout(this.master_timer);
      // Menu reaberto com o erro da troca anterior, ou nova busca digitada
      // por cima dele: nenhum dos dois ainda vale para o que o usuario esta
      // fazendo agora.
      this.switch_error = null;
      const term = this.master_query.trim();
      // Contador, nao cancelamento: a resposta de um termo antigo que chegue
      // depois da nova nao pode sobrescrever a lista.
      const request = ++this.master_request;

      if (term.length < MIN_SEARCH_LENGTH) {
        this.master_results = [];
        this.master_status = "idle";
        return;
      }

      this.master_status = "loading";
      this.master_timer = setTimeout(() => {
        this.auth_svc
          .search_master_accounts(term)
          .then(({ data }) => {
            if (request !== this.master_request) return;
            this.master_results = data || [];
            this.master_status = "idle";
          })
          .catch((err) => {
            if (err && err.response && err.response.status === 401) {
              this.handle_session_expired();
              return;
            }
            if (request !== this.master_request) return;
            this.master_results = [];
            this.master_status = "error";
          });
      }, SEARCH_DEBOUNCE_MS);
    },
    switch_account(account) {
      if (this.switching_account || (account.id !== null && account.id === this.current_account_id)) {
        this.account_menu_open = false;
        return;
      }

      this.switching_account = true;
      this.switch_error = null;

      this.auth_svc
        .switch_account(account)
        .then(({ data }) => {
          const target = redirectUrlFor(account.type, data.token, {
            providerUrl: CONSTANTS.PROVIDER_URL,
            adminUrl: CONSTANTS.ADMIN_URL,
          });

          // Sem destino configurado, nada de logout: a sessao atual continua
          // valida e o usuario fica onde esta.
          if (!target) {
            this.switching_account = false;
            this.switch_error = "URL de redirecionamento não configurada para esta conta.";
            return;
          }

          if (isSameApp(account.type)) {
            // Trocar de conta NAO e so trocar o token: o store guarda perms,
            // lojas, settings, cli_id e companhia da conta anterior em
            // localStorage. Reaproveitar o `logout` garante que essa limpeza
            // acompanhe o que o store de fato guarda, em vez de duplicar a
            // lista aqui e sair de sincronia na proxima chave nova.
            this.$store.dispatch("user/logout");

            // Cliente volta pelo mesmo caminho do login (routes.js grava o
            // ?token=).
            window.location.href = target;
            return;
          }

          // Saida para outro app (fornecedor ou admin) nao pode derrubar a
          // sessao deste painel no meio da navegacao: o reset do logout e
          // sincrono e as paginas reativas (monitor de cotacoes, eventos)
          // refazem suas chamadas antes do browser sair, tomam 401 sem token
          // e o tratamento delas redireciona para /login, cancelando a
          // entrega do target aqui. O app de destino adota o token novo
          // sozinho, entao o logout daqui nem faz falta.
          window.location.assign(target);
        })
        .catch(() => {
          // Recusa (empresa desativada, master revogado) nao derruba a sessao:
          // mostra o erro e recarrega a lista, que pode ter mudado.
          this.switching_account = false;
          this.switch_error = "Não foi possível entrar nesta conta agora.";
          this.load_switchable_accounts();
        });
    },
  },
  mounted() {
    this.load_switchable_accounts();
  },
  beforeDestroy() {
    clearTimeout(this.master_timer);
  },
  watch: {
    present_numbers(current) {
      if (current) {
        gsap.fromTo(
          "#contacts",
          { x: "100%" },
          { x: "50%", duration: 1, ease: "back.out(1.7)" }
        );
      } else {
        gsap.fromTo(
          "#contacts",
          { x: "0%" },
          { x: "170%", duration: 1, ease: "back.out(1.7)" }
        );
      }
    },
  },
  computed: {
    ...mapState(["user", "whitelabel"]),
    ...mapGetters(["version"]),
    can_switch_account() {
      // Master sempre pode trocar: a busca alcanca qualquer empresa ativa.
      return this.switchable_accounts.length > 1 || this.is_master;
    },
    visible_master_results() {
      // A conta master em que o usuario esta agora ja aparece na lista de
      // cima como atual; o servidor nao sabe disso e a devolveria de novo.
      const ids = this.switchable_accounts.map((a) => a.id).filter((id) => id !== null);
      return this.master_results.filter((a) => a.id === null || !ids.includes(a.id));
    },
  },
};
</script>

